import { render, staticRenderFns } from "./serviceList.vue?vue&type=template&id=01ad4092&scoped=true"
import script from "./serviceList.vue?vue&type=script&lang=js"
export * from "./serviceList.vue?vue&type=script&lang=js"
import style0 from "./serviceList.vue?vue&type=style&index=0&id=01ad4092&prod&scoped=true&lang=css"
import style1 from "./serviceList.vue?vue&type=style&index=1&id=01ad4092&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ad4092",
  null
  
)

export default component.exports